import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@tq/ui-components';

// should these be read from the JSON file?
export enum StandardDateFormats {
  fileNameSuffix = 'fileNameSuffix',
  date = 'date',
  dateAndTime = 'dateAndTime',
}

type DateFormats = Record<StandardDateFormats, string>;

export const defaultValues: DateFormats = {
  date: 'dd MMM yyyy',
  dateAndTime: 'dd MMM yyyy HH:mm',
  fileNameSuffix: 'dd MMM yyyy',
};

export type FormatLocaleDateReturnType = (
  dateValue: Date | string | undefined,
  format?: StandardDateFormats
) => string;

export const useFormatLocaleDate = (): FormatLocaleDateReturnType => {
  const { t } = useTranslation('_dateFormats');

  return useCallback(
    (dateValue: Date | string | undefined, format?: StandardDateFormats) => {
      const returnFormat = format ?? StandardDateFormats.date;

      let parsedFormat = t(returnFormat, defaultValues[returnFormat]);
      if (parsedFormat === '') {
        parsedFormat = defaultValues.date;
      }

      return formatDate(dateValue, parsedFormat);
    },
    [t]
  );
};
